import { render, staticRenderFns } from "./EventMain.vue?vue&type=template&id=51b766c1&scoped=true&"
import script from "./EventMain.vue?vue&type=script&lang=js&"
export * from "./EventMain.vue?vue&type=script&lang=js&"
import style0 from "./EventMain.vue?vue&type=style&index=0&id=51b766c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b766c1",
  null
  
)

export default component.exports